
import axios from 'axios'

export const searchCategories = async (organizationId, keyword = "") => {
  const params = keyword ? `?keyword=${encodeURIComponent(keyword)}` : "";
  const response = await axios.get(`/organization/${organizationId}/category${params}`);
  return response?.data?.categories ?? [];
};
